import DOMPurify from "dompurify";
import { allowedRichTextAttributes, allowedRichTextTags } from "./defaults";

export function sanitiseText(html: string): string {
  if (!html.trim()) return "";

  const sanitisedHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: allowedRichTextTags,
    ALLOWED_ATTR: allowedRichTextAttributes,
    ALLOW_DATA_ATTR: false,
  }).trim();

  if (!sanitisedHtml) return "";

  const document = new DOMParser().parseFromString(sanitisedHtml, "text/html");
  document.body.querySelectorAll("*").forEach((element) => {
    if (element instanceof HTMLAnchorElement) {
      const normalisedHref = normaliseHref(element.getAttribute("href") ?? "");
      if (isValidHref(normalisedHref))
        element.setAttribute("href", normalisedHref);
      else element.removeAttribute("href");

      element.setAttribute("target", "_blank");
      element.setAttribute("rel", "noopener");
      return;
    }

    element.removeAttribute("href");
    element.removeAttribute("title");
    element.removeAttribute("target");
    element.removeAttribute("rel");
  });

  const normalisedHtml = document.body.innerHTML.trim();
  const textContent = document.body.textContent?.replace(/\u00a0/g, " ").trim();

  return textContent ? normalisedHtml : "";
}

export function normaliseHref(value: string): string {
  const href = value.trim();
  if (!href) return "";
  if (/^[a-z][a-z\d+.-]*:/i.test(href)) return href;
  if (/^(?:\/|#|\?)/u.test(href)) return href;
  return `https://${href}`;
}

export function isValidHref(value: string): boolean {
  if (!value) return false;

  try {
    const url = new URL(value);
    return url.protocol === "https:" && Boolean(url.hostname);
  } catch {
    return false;
  }
}

export function hasMissingAssessmentText(
  value: unknown,
  richText: boolean,
): boolean {
  if (typeof value !== "string") return true;
  return richText ? sanitiseText(value) === "" : value.trim() === "";
}
